// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"Referrals","362":"Dashboard","523":"Visit","565":"Payouts"}[chunkId] || chunkId) + "." + {"126":"24cdb4d0","215":"32cd6ec7","226":"b3b0f10e","362":"fb5860dd","482":"95f7144f","523":"be644882","565":"4281addf","642":"9e31a03c"}[chunkId] + ".chunk.js";
};